import { invokeRPC } from './socket.js'

export function createSharedReportLink(data) {
  return invokeRPC('savedReportSharableLink', 'createSharedReportLink', data)
}

export function getSharedLinkReport(linkId) {
  return invokeRPC('savedReportSharableLink', 'getSharedLinkReport', { link_id: linkId })
}

export function getUsersForReportSharing(data) {
  return invokeRPC('userResources', 'getUsersForReportSharing', data)
}

export function shareSavedReport(data) {
  return invokeRPC('sharedReport', 'shareSavedReport', data)
}

export function createAndShareReport(data) {
  return invokeRPC('sharedReport', 'createAndShareReport', data)
}

export function getUsersWhoHaveAccessToReport(reportId) {
  return invokeRPC('sharedReport', 'getUsersWhoHaveAccessToReport', { report_id: reportId })
}

export function getSharedReportList(data) {
  return invokeRPC('sharedReport', 'getSharedReportList', data)
}

export function unshareReport(reportId) {
  return invokeRPC('sharedReport', 'unshareReport', { report_id: reportId })
}

export function getReport(reportId) {
  return invokeRPC('sharedReport', 'getReport', { report_id: reportId })
}

export function getReportPathData(reportId) {
  return invokeRPC('sharedReport', 'getReportPathData', { report_id: reportId })
}

export function sendEmail(data) {
  return invokeRPC('savedReportSharableLink', 'sendEmail', data)
}